import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap";

const TopSellingProductModal = ({ isOpen, toggle, topProducts }) => {
  return (
    <Modal isOpen={isOpen} size="lg" toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Top Selling Products</ModalHeader>
      <ModalBody>
        <Row>
          {topProducts?.topFiveItems?.length > 0 ? (
            topProducts.topFiveItems.map((product) => (
              <Col key={product.itemId} md={6}>
                <Card className="mb-4 p-2 bg-light">
                  <CardBody className="d-flex align-items-center gap-3">
                    <div
                      className="flex-shrink-0"
                      style={{
                        width: "60px",
                        height: "60px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={product?.displayImage?.getCDNUrl()}
                        alt={product.title}
                        className="img-fluid rounded"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div>
                      <h5 className="mb-0">{product.title}</h5>
                      <p className="mb-0">Total Sold: {product.quantity}</p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))
          ) : (
            <Col>
              <p>No top selling products available</p>
            </Col>
          )}
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default TopSellingProductModal;
